import { ObjectKind } from "@/apps/tatar/objectsApp/types/objectKind.interface";
import i18n from "@/i18n";
import { Group } from "@/model/db/Group";
import BFButton from "../../general/Button/BFButton";
import BFUseTooltip from "../../general/tooltip/BFUseTooltip";
import { ObjectKindPermission } from "./BFObjectKindPermission";

interface FieldSelectLabelProps {
  value: string[];
  options: { value: string; label: string }[];
  group?: Group;
  otherValues?: {
    group: Group;
    value: string[];
  }[];
}

export const BFPermissionFieldSelectLabel = (props: FieldSelectLabelProps) => {
  let permissions = props.value?.map((value) => {
    let perm = {
      label: props.options.find((e) => e.value === value)?.label,
      groups: props.group ? [props.group] : undefined,
    };

    props.otherValues?.forEach((otherValue) => {
      if (otherValue.value?.includes(value)) {
        perm.groups.push(otherValue.group);
      }
    });

    return perm;
  });

  if (
    !Array.isArray(props.options) ||
    !Array.isArray(permissions) ||
    !permissions.length
  ) {
    return <div className={`readonly-values`}>-</div>;
  }

  return (
    <div className={`readonly-values`}>
      {Array.isArray(permissions) &&
        permissions?.map((perm, iPerm) => {
          if (perm.groups && perm.groups.length > 0) {
            return (
              <>
                {perm.groups && perm.groups.length > 0 && (
                  <>
                    {perm.label}
                    <ConnectedGroupsList groups={perm.groups} />
                  </>
                )}
                {!perm.groups || (perm.groups.length <= 0 && "-")}
                {iPerm < permissions.length - 1 && ", "}
              </>
            );
          } else {
            return <p>{perm.label}</p>;
          }
        })}
    </div>
  );
};

interface BooleanLabelProps {
  value: boolean;
  group?: Group;
  otherValues?: { group: Group; value: boolean }[];
}

export const BFPermissionFieldBooleanLabel = (props: BooleanLabelProps) => {
  let value = props.value ? props.value : false;
  const label = value ? i18n.t("Global.Labels.yes", "Ja") : "-";
  let groups = props.group ? [props.group] : undefined;

  props.otherValues?.forEach((otherValue) => {
    if (otherValue.value) {
      groups.push(otherValue.group);
    }
  });

  return (
    <div className={`readonly-values`}>
      {label}
      {groups && value && <ConnectedGroupsList groups={groups} />}
    </div>
  );
};

interface ObjectKindLabelProps {
  kind: ObjectKind;
  permissionKey: string;
  group: Group;
  value: ObjectKindPermission[];
  otherValues: {
    group: Group;
    value: ObjectKindPermission[];
  }[];
}

export const BFPermissionFieldObjectKindLabel = (
  props: ObjectKindLabelProps
) => {
  if (!props.group) return;
  const checked: boolean = props.value
    .find((v) => v.objectKindId === props.kind._id)
    ?.permissions.includes(props.permissionKey);

  let groups = [];

  if (checked) {
    groups.push(props.group);
  }

  props.otherValues.forEach((e) => {
    if (
      e.value
        .find((v) => v.objectKindId === props.kind._id)
        ?.permissions.includes(props.permissionKey)
    ) {
      groups.push(e.group);
      return;
    }
  });

  if (checked) {
    return <ConnectedGroupsList groups={groups} />;
  }
};

export const ConnectedGroupsList = (props: { groups: Group[] }) => {
  return (
    <span>
      {" ("}
      {props.groups.map((g, i) => {
        return (
          <BFUseTooltip placement="auto" tooltip={<>{`${g.id} - ${g.name}`}</>}>
            <BFButton
              style={{ display: "inline", padding: "0" }}
              appearance="link"
              href={`/administration/group/${g._id}/data`}
              target="_blank"
            >
              {g.id}
              {i < props.groups.length - 1 && ","}
            </BFButton>
          </BFUseTooltip>
        );
      })}
      {")"}
    </span>
  );
};
